import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SocketProvider } from './contexts/SocketContext';
import ConnectionStatus from './components/ConnectionStatus';
import LandingPage from './components/LandingPage';
import ExplorePage from './components/ExplorePage';
import GameRulesPage from './components/rules/GameRulesPage';
import RoomPage from './components/RoomPage';
import LeagueNewPage from './components/league/LeagueNewPage';
import LeaguePage from './components/league/LeaguePage';
import LeagueReplayPage from './components/league/LeagueReplayPage';
import StumbleHomeMapMaker from './components/games/stumble-home/StumbleHomeMapMaker';
import './App.css';

function App() {
  return (
    <SocketProvider>
      <Router>
        <ConnectionStatus />
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/games/:id" element={<GameRulesPage />} />
            <Route path="/room/:slug" element={<RoomPage />} />
            <Route path="/leagues/new" element={<LeagueNewPage />} />
            <Route path="/league/:id" element={<LeaguePage />} />
            <Route path="/league/:id/replay/:gameId" element={<LeagueReplayPage />} />
            <Route path="/stumble-home/map-maker" element={<StumbleHomeMapMaker />} />
          </Routes>
        </div>
      </Router>
    </SocketProvider>
  );
}

export default App;